import React, { useEffect } from 'react';
import classnames from 'classnames';
import { generalStore } from '../../store';
import Config from '../../js/config/_global';
import './Alert.scss';
import Button from '../button/Button';
import CloseButton from '../closeButton/CloseButton';


const Alert = () => {
    const { resetAlert, hideAlert, alert } = generalStore();
    const {
        onClose,
        onClick,
        actionButtonText,
        display,
        isAutoDisappearing = true,
        message,
        type,
        position,
    } = alert;

    const hideAfterTime = () => {
        setTimeout(() => {
            hideAlert();
        }, Config.alertDuration);
    };

    const handleCloseAlert = () => {
        if(onClose) {
            onClose();
        }
        hideAlert();
    }

    const handleClick = () => {
        resetAlert();

        if (onClick) {
            onClick();
        }
    };

    useEffect(() => {
        if (display && isAutoDisappearing) {
            hideAfterTime();
        }
    });

    const classes = classnames('b-alert', type, position, {
        'is-displayed': display
    });

    return (
        <div className={classes}>
            <CloseButton
                className="b-alert__close-button"
                onClick={handleCloseAlert}
            />
            <div className="b-alert__content-wrapper">
                <p
                    role="alert"
                    aria-relevant="all"
                    className={classnames('alert-text', type)}
                >
                    {message}
                </p>
                {onClick && (
                    <Button clickHandler={handleClick}>
                        {actionButtonText}
                    </Button>
                )}
            </div>
        </div>
    );
};

export { Alert };

export default Alert;
